import { render, staticRenderFns } from "./yydjList.vue?vue&type=template&id=7973b758&scoped=true&"
import script from "./yydjList.vue?vue&type=script&lang=js&"
export * from "./yydjList.vue?vue&type=script&lang=js&"
import style0 from "./yydjList.vue?vue&type=style&index=0&id=7973b758&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7973b758",
  null
  
)

export default component.exports